import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AdminSetupService } from "../../services/adminsetup.service";
import * as moment from "moment";

@Component({
	selector: "app-adjust-menu",
	templateUrl: "./adjust-menu.component.html",
	styleUrls: ["./adjust-menu.component.css"],
})
export class AdjustMenuComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private adminSetupService: AdminSetupService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get Data from Parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.UserID = this.dialogConfig.data.UserID;
		this.lstPref = this.dialogConfig.data.lstPref;

		//Get Data from DB
		this.UpdateData();
	}

	//////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////

	SchoolID: any = 0;
	UserID: any;

	LargerWindow: boolean = false; //Resize window to fit date picker

	CalendarTypeID: any = 1;
	lstCalendarType: any = [
		{
			CalendarTypeID: 1,
			CalendarTypeDesc: "Fixed",
		},
		{
			CalendarTypeID: 2,
			CalendarTypeDesc: "Rotating",
		},
	];

	lstPref: any = [];

	SkipClosedDay: any = false;
	UseSchoolBellSchedule: any = false;
	StartDate: Date = new Date();

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////
	UpdateData() {
		for (var i = 0; i < this.lstPref.length; i++) {
			var next = this.lstPref[i];

			if (next.KeyName == "CalendarDayType") {
				this.CalendarTypeID = Number(next.KeyValue);
			} else if (next.KeyName == "SkipClosedDay") {
				this.SkipClosedDay = next.KeyValue == "True" ? true : false;
			} else if (next.KeyName == "UseSchoolDayBellSchedule") {
				this.UseSchoolBellSchedule = next.KeyValue == "True" ? true : false;
			}
		}
	}
	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////

	onUpdate() {
		var Today = new Date();
		Today.setHours(0, 0, 0);

		//Start Date < and not equal to
		if (this.StartDate < Today && this.StartDate.toString() != Today.toString()) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Select a Start Date >= Today",
				header: "ERROR BAD INPUT",
				icon: "fa",
				accept: () => {},
			});
			return;
		}

		var result = this.adminSetupService.CalendarAdjustment(
			this.CalendarTypeID == 1 ? 1 : 0,
			this.SkipClosedDay == true ? 1 : 0,
			this.UseSchoolBellSchedule == true ? 1 : 0,
			moment(this.StartDate).format("MM/DD/YYYY"),
			this.SchoolID,
			this.UserID
		);
		result.subscribe(
			(response) => {
				//Success Message
				if (response) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Calendar Successfully Adjusted",
						header: "Calendar Adjustments",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				}
				//Fail Message
				else {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the calendar",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	onCalendarGrow() {
		this.LargerWindow = true;
	}
	onCalendarShrink() {
		this.LargerWindow = false;
	}

	//////////////////////////////////////////////
}
